import axios from 'axios';
import { getUrlString } from '../assets/js/utils';
import store from '../store/store.js';
import $ from 'webpack-zepto';

let devApi = '//msinner.jr.jd.com/gw/generic/base/h5/m/' //预发
let proApi = '//ms.jr.jd.com/gw/generic/base/h5/m/' //生产
let debugApi = './static/data/'
let apiHostname = process.env.NODE_ENV == "development" ? devApi : (process.env.NODE_ENV == "production" ? proApi : '');
console.log(process.env.NODE_ENV, apiHostname)

if(apiHostname == "") {
    console.log('确认系统环境变量设置')
}

export const apiUrl = window.location.href.indexOf("debug") > -1 ? {
    checkLousUser: debugApi + "checkLousUser.json", //是否是白条用户
    getUserBaseInfoAndActivity: debugApi + 'getUserBaseInfoAndActivity.json', //用户信息和活跃度
    queryBenefitBaseInfo: debugApi + "queryBenefitBaseInfo.json", //待领取权益id列表
    queryBenefitDetailInfo: debugApi + 'queryBenefitDetailInfo.json',   //权益详情 （根据上面获取的id 调用详情）
    benefitSend: debugApi + "benefitSend.json", //领取权益
    queryBenefitSaleList: debugApi + "queryBenefitSaleList.json", //权益特卖
    getHomePageMisssion: debugApi + "getHomePageMisssion.json", //首页任务
    qryBenefitList: debugApi + "qryBenefitList1.json", // 甄选
    jrmSignMission: debugApi + "jrmSignMission.json", //签到
    jrmReceiveMission: debugApi + "jrmReceiveMission.json", //领任务
    jrmRewardMission: debugApi + "jrmRewardMission.json", //领奖励
    getAllUndoMissions: debugApi + "getAllUndoMissions.json", //全部任务id列表
    getMissionStatusById: debugApi + "getMissionStatusById.json", //根据id获取任务详情
    getAllFinishMissions: debugApi + "getAllFinishMissions.json", //已完成任务列表
}:{
    checkLousUser: apiHostname + "checkLousUser", //是否是白条用户
    getUserBaseInfoAndActivity: apiHostname + 'getUserBaseInfoAndActivity', //用户信息和活跃度
    queryBenefitBaseInfo: apiHostname + "queryBenefitBaseInfo", //待领取权益id列表
    queryBenefitDetailInfo: apiHostname + "queryBenefitDetailInfo", //权益详情 （根据上面获取的id 调用详情）
    benefitSend: apiHostname + "benefitSend", //领取权益
    queryBenefitSaleList: apiHostname + "queryBenefitSaleList", //权益特卖
    getHomePageMisssion: apiHostname + "getHomePageMisssion", //首页任务
    qryBenefitList: apiHostname + "qryBenefitList", // 甄选
    jrmSignMission: apiHostname + "jrmSignMission", //签到
    jrmReceiveMission: apiHostname + "jrmReceiveMission", //领任务
    jrmRewardMission: apiHostname + "jrmRewardMission", //领奖励
    getAllUndoMissions: apiHostname + "getAllUndoMissions", //全部任务id列表
    getMissionStatusById: apiHostname + "getMissionStatusById", //根据id获取任务详情
    getAllFinishMissions: apiHostname + "getAllFinishMissions", //已完成任务列表
}



//
function convert(param) {
    param = param || {};

    let accessKey = getUrlString("accessKey");
    let requestData = {
        accessKey: accessKey,
        reqData: JSON.stringify(param)
    };

    return {
        params: requestData
    };
};

//
export const getData = function(param, cb, errorCb) {
    let requestData = convert(param.data);
    let params = {
        url: param.url,
        data: requestData
    };

    ajax("get", params, cb, errorCb);
}

//
export const postData = function(param, cb, errorCb) {
    let requestData = convert(param.data);
    let params = {
        url: param.url,
        data: requestData.params
    };

    ajax("post", params, cb, errorCb);
}

//xhr
function ajax(method, param, cb, errorCb) {

    let methodInvoke = axios[method.toLowerCase()];

    let postConfig = param.config || {};
    let getConfig = Object.assign({}, postConfig, param.data, {withCredentials: true});

    let promise = method == "get" ? methodInvoke(param.url, getConfig) : methodInvoke(param.url, param.data, postConfig);

    promise.then(function(res) {
        try {
            cb && cb(res.data);
        } catch (error) {
            errorCb && errorCb("系统现在有点忙，请稍后再试~");
        }
    }).catch(function(error) {

        errorCb && errorCb("网络连接异常，请稍后再试~");
    });
}

//
export const getDataSuccess = function(params, success) {
    let requestData = convert(params.data);
    let param = {
        url: params.url,
        data: requestData
    };

    let methodInvoke = axios["get"];
    let getConfig = Object.assign({}, param.config, param.data, {withCredentials: true});
    let promise = methodInvoke(param.url, getConfig);

    promise.then(function(rst) {
        let res = rst.data
        //网关接口状态
        if(res.resultCode == 0) {
            let result = res.resultData
            //业务系统状态

            success && success(result)
        }else{
            window.vue && window.vue.$emit("gateWayError", res);
        }

    }).catch(function(error) {
        let msg = '网络连接异常，请稍后再试~'
        window.vue && window.vue.$emit("serverError", msg);
    });
}


export const getAysnDataSucc = function(data, callback) {
    $.ajax({
        url: data.url,
        data: {reqData:JSON.stringify(data.data)},
        type: "GET",
        xhrFields: {
            withCredentials: true
        },
        async: false,
        success: function(res) {

            if(res.resultCode == "0") {
                callback && callback(res.resultData);
            }else{
                window.vue && window.vue.$emit("gateWayError", res);
            }

        }
    })
}






// WEBPACK FOOTER //
// ./src/utils/api.js